import PageHandlersService from '@/utils/page-handlers-service';

const pageHandlers = new PageHandlersService();

const init = () => {
    const mobilePopup = document.querySelector('.js-mobile-filter-popup');

    pageHandlers.set('.js-partner-hero-contacts-btn', () => {
        mobilePopup?.classList.add('active');
    });

    pageHandlers.set('.js-partner-mobile-popup-close', () => {
        mobilePopup?.classList.remove('active');
    });

    const contentBlocks = document.querySelectorAll('.js-content');

    contentBlocks.forEach((block) => {
        const blockLinks = block.querySelectorAll('a');

        blockLinks.forEach((link) => {
            link.classList.add('link');
            link.classList.add('link--underlined');
        });
    });

    const videoContainers = document.querySelectorAll('.js-video-visual-part');
    const cursor = document.querySelector('.cursor');

    videoContainers.forEach((container) => {
        const videoPopup = container.querySelector('.js-video-popup');
        const frameContainer = videoPopup?.querySelector('.js-video-popup-frame-container');
        const videoFrame = frameContainer?.querySelector('iframe');
        const closeButtons = container.querySelectorAll('.js-video-popup-close-btn');
        const videoPlayButton = container.querySelector('.js-video-play-btn');

        videoFrame?.classList.add('video-popup__iframe');
        if (videoFrame) {
            videoFrame.dataset.src = videoFrame?.src;
        }

        let videoSrcResetTimeout: NodeJS.Timeout;
        let isFirstTimeOpening = true;

        const handleWatchButtonClick = () => {
            videoPopup?.classList.add('active');
            cursor?.classList.add('cursor--force-hidden');

            if (videoSrcResetTimeout) {
                clearTimeout(videoSrcResetTimeout);
            }

            if (isFirstTimeOpening) {
                videoFrame?.setAttribute('src', videoFrame.dataset.src ?? '');
                isFirstTimeOpening = false;
            }
        };

        const handleCloseButtonClick = () => {
            videoPopup?.classList.remove('active');

            videoSrcResetTimeout = setTimeout(() => {
                videoFrame?.setAttribute('src', videoFrame.src);
                cursor?.classList.remove('cursor--force-hidden');
            }, 600);
        };

        pageHandlers.set(videoPlayButton, handleWatchButtonClick);

        closeButtons.forEach((closeButton) => {
            pageHandlers.set(closeButton, handleCloseButtonClick);
        });
    });
};

const destroy = () => pageHandlers.clear();

const _module = { init, destroy };

export default _module;
